import React from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { Section } from './Section';
import { CtaButton } from './CtaButton';
import { tomos, insideEachTomo } from '../data/tomos';
export function Tomes() {
  return <Section tone="white" data-id="element-213" data-mp="1tyxv7h71ar4x">
      <h2 className="mx-auto max-w-[24ch] text-center font-serif text-[28px] leading-tight sm:text-4xl" data-id="element-214" data-mp="1ty5y21xsglcj">
        Seis tomos. Un negocio completo. Cero improvisación.
      </h2>

      <ul className="mt-14 flex flex-col gap-6" data-id="element-215" data-mp="1l15gae585li2">
        {tomos.map(tomo => <li key={tomo.number} className={`card-editorial overflow-hidden ${tomo.featured ? 'border-gold/60' : ''}`} data-id="element-216" data-mp="1fzg0kl724jnn">
            <article className="grid gap-6 p-6 sm:grid-cols-[160px,1fr] sm:gap-8 sm:p-8" data-id="element-217" data-mp="16339zw6t6lx4">
              <img src={tomo.image} alt={tomo.alt} className="h-full max-h-[240px] w-full rounded-card border border-gold-line object-cover sm:max-h-none" loading="lazy" data-id="element-218" data-mp="35fxnictdt5yy" />

              <div className="flex flex-col" data-id="element-219" data-mp="27fm1lab0x102">
                <div className="flex flex-wrap items-center gap-3" data-id="element-220" data-mp="2cgjhfg8k9iye">
                  <p className="kicker" data-id="element-221" data-mp="2cdnjvt0mkwah">{tomo.number}</p>
                  {tomo.featured && <span className="rounded-card bg-gold-tint px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-gold-dark" data-id="element-222" data-mp="1xl3udv6eenbi">
                      {tomo.featuredLabel}
                    </span>}
                </div>

                <h3 className="mt-3 font-serif text-2xl leading-tight sm:text-[28px]" data-id="element-223" data-mp="2v5getsz98rku">
                  {tomo.title}
                </h3>
                <p className="mt-2 text-[13px] uppercase tracking-[0.1em] text-ink-muted" data-id="element-224" data-mp="2gfis7hgz49xr">
                  {tomo.subtitle}
                </p>

                <p className="mt-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-225" data-mp="3960tccy5018j">
                  {tomo.body}
                </p>

                <p className="mt-5 flex items-start gap-2.5 border-t border-gold-line pt-5 text-[15px] font-medium text-ink" data-id="element-226" data-mp="3dyk7pc4nf0ee">
                  <ArrowRightIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-227" data-mp="3nqlqi1a51ngr" />
                  {tomo.outcome}
                </p>
              </div>
            </article>
          </li>)}
      </ul>

      <div className="mt-14 rounded-card border border-gold-line bg-ivory p-7 sm:p-9" data-id="element-228" data-mp="39vaziyz0lmho">
        <h3 className="font-serif text-xl sm:text-2xl" data-id="element-229" data-mp="34vop0xakmkck">Dentro de cada tomo</h3>
        <ul className="mt-6 grid gap-3.5 md:grid-cols-2" data-id="element-230" data-mp="302c879c4vhud">
          {insideEachTomo.map(item => <li key={item} className="flex items-start gap-3" data-id="element-231" data-mp="2v53qf9uwdftn">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-232" data-mp="2r2ywea0jeh6h" />
              <span className="text-[15px] leading-relaxed text-ink-soft" data-id="element-233" data-mp="2m5go8lucg5zj">
                {item}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="mt-12 flex justify-center" data-id="element-234" data-mp="wlywwt2sneqn">
        <CtaButton data-id="element-235" data-mp="11lbkxh5eirut">Quiero el sistema completo</CtaButton>
      </div>
    </Section>;
}